import React from 'react';

export const TableSkeleton = ({ rows = 5, cols = 6 }) => (
    <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
        <div className="border-b border-gray-100 px-4 py-3 flex gap-4">
            {Array.from({ length: cols }).map((_, i) => (
                <div key={i} className="skeleton h-3 rounded" style={{ width: `${60 + Math.random() * 60}px` }} />
            ))}
        </div>
        {Array.from({ length: rows }).map((_, i) => (
            <div key={i} className="px-4 py-3 flex gap-4 border-b border-gray-50">
                {Array.from({ length: cols }).map((_, j) => (
                    <div key={j} className="skeleton h-3 rounded" style={{ width: `${40 + Math.random() * 80}px` }} />
                ))}
            </div>
        ))}
    </div>
);

export const CardSkeleton = ({ count = 4 }) => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {Array.from({ length: count }).map((_, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-100 p-4">
                <div className="skeleton h-3 w-20 mb-3 rounded" />
                <div className="skeleton h-8 w-16 mb-2 rounded" />
                <div className="skeleton h-2 w-12 rounded" />
            </div>
        ))}
    </div>
);

export const FormSkeleton = ({ fields = 6 }) => (
    <div className="bg-white rounded-xl border border-gray-100 p-6 space-y-4">
        {Array.from({ length: fields }).map((_, i) => (
            <div key={i}>
                <div className="skeleton h-3 w-24 mb-2 rounded" />
                <div className="skeleton h-9 w-full rounded" />
            </div>
        ))}
    </div>
);

export const PageSkeleton = ({ type = 'table' }) => {
    if (type === 'table') return <TableSkeleton />;
    if (type === 'cards') return <CardSkeleton />;
    if (type === 'form') return <FormSkeleton />;
    return <TableSkeleton />;
};
